import React from 'react';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import SmoothScroll from '../elements/SmoothScroll';
import { company, goddessMecha, ibashoTown } from '../../data/products';

const propTypes = {
  ...SectionProps.types
}

const defaultProps = {
  ...SectionProps.defaults
}

const Hero = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {

  const outerClasses = classNames(
    'hero section center-content company-hero',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'hero-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container-sm">
        <div className={innerClasses}>
          <div className="hero-content">
            <p className="company-hero-eyebrow text-xxs reveal-from-bottom" data-reveal-delay="100">
              Independent studio · Seoul
            </p>
            <h1 className="mt-0 mb-16 reveal-from-bottom" data-reveal-delay="200">
              {company.name}
            </h1>
            <div className="container-xs">
              <p className="m-0 mb-32 reveal-from-bottom" data-reveal-delay="400">
                {company.tagline}<br />
                Pixel-art defense on mobile, and an interactive story town on the web.
              </p>
            </div>
          </div>
          <div className="company-hero-cards reveal-from-bottom" data-reveal-delay="600">
            <SmoothScroll to={goddessMecha.id} className="company-hero-card company-hero-card-gm">
              <img src="/img/gm/icon.png" alt="" width={56} height={56} />
              <span className="company-hero-card-body">
                <span className="company-hero-card-title">{goddessMecha.name} <small>{goddessMecha.nameJa}</small></span>
                <span className="company-hero-card-sub text-xs">{goddessMecha.tagline}</span>
                <span className="company-hero-card-meta text-xxs">{goddessMecha.platform}</span>
              </span>
            </SmoothScroll>
            <SmoothScroll to={ibashoTown.id} className="company-hero-card company-hero-card-it">
              <img src="/img/ibasho/icon.svg" alt="" width={56} height={56} />
              <span className="company-hero-card-body">
                <span className="company-hero-card-title">{ibashoTown.name} <small>{ibashoTown.nameJa}</small></span>
                <span className="company-hero-card-sub text-xs">{ibashoTown.slogan}</span>
                <span className="company-hero-card-meta text-xxs">{ibashoTown.platform}</span>
              </span>
            </SmoothScroll>
          </div>
        </div>
      </div>
    </section>
  );
}

Hero.propTypes = propTypes;
Hero.defaultProps = defaultProps;

export default Hero;
